import { render, staticRenderFns } from "./AddCoverageSelector.vue?vue&type=template&id=67e9433e&scoped=true&"
import script from "./AddCoverageSelector.vue?vue&type=script&lang=js&"
export * from "./AddCoverageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9433e",
  null
  
)

export default component.exports